export default __webpack_public_path__ + "locales/si/InviteDialog.json?hash=f2a9e7e17107348fc1bce600d90ad87d";